import React, { CSSProperties } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { Translator } from 'Translator';
import { LocationDescriptor } from 'history';

const langCode = Translator.getLanguageCode();

interface LocalizedLinkProps extends LinkProps {
  to: LocationDescriptor;
  className?: string;
  onClick?: (e: any) => void;
  target?: string;
  ariaHidden?: boolean;
  title?: string;
  style?: CSSProperties;
  rel?: string;
  itemType?: string;
  itemProp?: string;
  'data-test-id'?: string;
  component?: any;

  [key: string]: any;
}

const LocalizedLink = ({ component: Component = Link, to, ariaHidden, ...rest }: LocalizedLinkProps) => {
  let localizedTo;
  if (typeof to === 'string') {
    const toWithSlash = to.startsWith('/') ? to : `/${to}`;
    localizedTo = `${langCode !== 'en' && !to.startsWith(`/${langCode}/`) ? `/${langCode}` : ''}${toWithSlash}`;
  } else if (typeof to === 'object') {
    const toWithSlash = to.pathname.startsWith('/') ? to.pathname : `/${to.pathname}`;
    localizedTo = {
      ...to,
      pathname: `${langCode !== 'en' && !to.pathname.startsWith(`/${langCode}/`) ? `/${langCode}` : ''}${toWithSlash}`
    };
  }

  return (
    <Component
      to={localizedTo}
      aria-hidden={ariaHidden ? 'true' : null}
      {...rest}
    />
  );
};

export default LocalizedLink;
